import { each, size, keys } from 'underscore';
import Promise from 'bluebird';
import { updateSeasonalityNameFromMT } from '@bingads-webui-campaign/seasonality-id-name-utils';

function getSeasonalityAdjustmentId(query) {
  let seasonalityId;
  if (size(query.$and) > 1) {
    each(query.$and, (clause) => {
      if (each(keys(clause), (key) => {
        if (key === 'SeasonalityAdjustmentId') {
          seasonalityId = clause.SeasonalityAdjustmentId.$eq;
        }
      }));
    });
    return seasonalityId;
  }

  if (each(keys(query), (key) => {
    if (key === 'SeasonalityAdjustmentId') {
      seasonalityId = query.SeasonalityAdjustmentId.$eq;
    }
  }));
  return seasonalityId;
}

export const onBeforeApplySavedFilter = ({
  filters, scope, i18n, jsdata,
}) => {
  if (filters[1] && filters[1].query) {
    const id = getSeasonalityAdjustmentId(filters[1].query);
    if (id) {
      return updateSeasonalityNameFromMT({
        id, scope, i18n, jsdata,
      });
    }
  }
  return Promise.resolve();
};
